"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkButton = void 0;
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const slate_react_1 = require("slate-react");
// utils
const is_mark_active_1 = require("../utils/is-mark-active");
const toggle_mark_1 = require("../utils/toggle-mark");
const button_styles_1 = require("./button-styles");
function MarkButton({ format, icon, }) {
    const classes = button_styles_1.useStyles();
    const editor = slate_react_1.useSlate();
    const active = is_mark_active_1.isMarkActive(editor, format);
    return (react_1.default.createElement("button", { onMouseDown: (event) => {
            event.preventDefault();
            toggle_mark_1.toggleMark(editor, format);
        }, className: clsx_1.default(classes.button, { [classes.active]: active }) }, icon));
}
exports.MarkButton = MarkButton;
//# sourceMappingURL=mark-button.js.map